import { useReactiveVar } from '@apollo/client';
import { Navigate } from 'react-router-dom';

import { featureFlagsLoadedVar } from '@/graphql/reactiveVars';

import { RouteKey } from './navigationUtils';
import { useDefaultLandingPage } from './useDefaultLandingPage';
import { useCanAccessPage } from './usePageAccessLookup';

export interface GuardedPageRedirectProps {
  route: RouteKey;
}

export function GuardedPageRedirect({
  route,
  children,
}: React.PropsWithChildren<GuardedPageRedirectProps>) {
  const defaultLandingPage = useDefaultLandingPage();
  const canAccessCurrentPage = useCanAccessPage(route);
  const areFeatureFlagsLoaded = useReactiveVar(featureFlagsLoadedVar);

  if (canAccessCurrentPage) {
    return <>{children}</>;
  }

  // Some page checks read feature flags. FeatureFlagsProvider sets the flags in
  // an effect, after this guard first renders. Do not redirect until the flag
  // request completes or fails, because a redirect removes the requested URL.
  if (!areFeatureFlagsLoaded) {
    return null;
  }

  return <Navigate to={defaultLandingPage} replace />;
}
